import { Link } from "@tanstack/react-router";
import { FiChevronRight, FiHome } from "react-icons/fi";

export interface BreadcrumbItem {
  label: string;
  to?: string;
  params?: Record<string, string>;
  ariaLabel?: string;
  isHome?: boolean;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

export default function Breadcrumb({
  items,
  className = "mb-4",
}: BreadcrumbProps) {
  return (
    <nav aria-label="breadcrumb" className={className}>
      <ol
        className="breadcrumb mb-0 d-flex align-items-center"
        style={{ gap: "0.35rem" }}
      >
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <div
              key={index}
              className="d-flex align-items-center"
              style={{ gap: "0.35rem" }}
            >
              <li
                className={`breadcrumb-item d-flex align-items-center ${
                  isLast ? "active" : ""
                }`}
                {...(isLast && { "aria-current": "page" })}
                style={isLast ? { fontWeight: 500 } : undefined}
              >
                {item.to && !isLast ? (
                  <Link
                    to={item.to}
                    params={item.params}
                    aria-label={item.ariaLabel}
                    className={`text-primary text-decoration-none ${
                      item.isHome ? "" : "fw-regular"
                    }`}
                    style={
                      item.isHome
                        ? { display: "flex", alignItems: "center" }
                        : undefined
                    }
                  >
                    {item.isHome ? <FiHome size={18} /> : item.label}
                  </Link>
                ) : (
                  <span>{item.label}</span>
                )}
              </li>

              {!isLast && <FiChevronRight size={16} className="text-muted" />}
            </div>
          );
        })}
      </ol>
    </nav>
  );
}
